import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { noop, Observable, tap } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

import { CustomObject } from 'app/shared/modules/custom-objects/custom-objects.types';
import { AddObjectComponent } from '../modals/add-object/add-object.component';
import { ObjectsManagerActions } from '../state/actions';
import { ObjectsManagerState } from '../state/state';
import { AccountState } from '@state/account/state';
import { FeatureFlag } from '@core/enums';

@Component({
  selector: 'objects-manager-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectsManagerListComponent extends OnDestroyMixin implements OnInit {
  objectItems: CustomObject[];
  objectsManagerCount: number;
  objectsManagerTableColumns: string[];
  isLoading: boolean;
  private isInverseRelationshipOn = false;

  @Select(ObjectsManagerState.get) get$: Observable<CustomObject[]>;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly matDialog: MatDialog,
    private readonly store: Store,
  ) {
    super();

    this.objectItems = [];
    this.objectsManagerCount = 0;
    this.objectsManagerTableColumns = ['name'];
    this.isInverseRelationshipOn = this.store.selectSnapshot(
      AccountState.isFeatureEnabled(FeatureFlag.INVERSE_RELATIONSHIP),
    );
  }

  ngOnInit(): void {
    this.get$
      .pipe(
        untilComponentDestroyed(this),
        tap((objects) => {
          this.objectItems = objects.filter((x) => x.linkable);

          if (!this.isInverseRelationshipOn) {
            this.objectItems = this.objectItems.filter((x) => x.id);
          }

          this.objectsManagerCount = this.objectItems.length;
          this.isLoading = false;
          this.changeDetectorRef.markForCheck();
        }),
      )
      .subscribe(noop);

    this.getObjects();
  }

  private getObjects(): void {
    this.isLoading = true;
    this.changeDetectorRef.markForCheck();
    this.store.dispatch(new ObjectsManagerActions.Get());
  }

  addCustomObject(): void {
    this.matDialog.open(AddObjectComponent, {
      panelClass: 'mailbox-compose-dialog',
    });
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
